



















































































































































































































































































































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator';
import SelectNodeField from '@c/controls/selectControls/SelectNodeField.vue';
import {
  DtcpEnergyModule,
  PModuleMeasurementTableHeader,
  PModuleMAC,
} from '@/views/system/modules/interfaces';
import PModuleMeasurementEditDialog from '@v/system/modules/forms/PModuleMeasurementEditDialog.vue';
import Table from '@c/tables/Table.vue';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import {PModuleMeasurementStore} from '@/views/system/modules/forms/pModuleMeasurementStore';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {PModuleType} from '@/enums/configs';
import {connectionGetActiveDevices} from '@/api/configApi';
import dtcpServerStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpServerStoreModule';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {updateMeasurements} from '../../moduleUtils';
import {httpClient} from '@/api/baseApi';
import PModuleButtons from './../../../nodes/PModuleButtons.vue';
import nodeModule from '@/store/modules/entities/nodeModule';

@Component({
  components: {
    Table,
    TableCheckBox,
    SelectNodeField,
    PModuleMeasurementEditDialog,
    IconButton,
    CancelChangesDialog,
    PModuleButtons,
  },
})
export default class DtcpEnergyModuleForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  nodeName: any = null;

  measurementDialog = PModuleMeasurementEditDialog;

  // список mac адресов для выбора
  macs: PModuleMAC[] = [];

  socket!: WebSocket | null;

  @Provide()
  @Prop({required: true})
  pmodule!: DtcpEnergyModule;

  @Prop({required: false})
  mac?: string;

  @Prop({required: false})
  fromHardware?: boolean;

  showMac = true;
  showStatChannel = false;
  showAdcChannel = false;
  showCoefA = false;
  showCoefB = false;
  showCoefC = false;
  showCoefD = false;
  showMeasCount = false;
  showMeasPeriodMks = false;
  showAdcMode = false;
  showRawSignalChannel = false;
  showFftBeansCount = false;
  showAmpSpectrChannel = false;

  am: any = [];

  get parentPmOptions() {
    return pmoduleModule.all.filter(
      m =>
        m.guid !== this.pmodule.guid &&
        m.guid &&
        (m.type === PModuleType.DtcpServerModule || m.type === PModuleType.DtcpEmulatorModule),
    );
  }

  get measurementsStore() {
    return new PModuleMeasurementStore(this.pmodule);
  }

  measurementsHeaders: PModuleMeasurementTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
  ];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';

  positiveNumberRule = (v: any) => v > 0 || 'Поле должно быть положительным числом';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonMACAddressRule = (v: any) => this.RegExPattern.test(v) || 'Поле должно быть МАС адресом';

  async onSave() {
    this.pmodule.measurements = this.pmodule.measurements.filter((x: any) => x.isActive === true);

    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }

    this.$emit('save');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      const newEntities = measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  amFieldClick() {
    router.push(`/hardware/${this.am.id}`);
  }

  async loadAM() {
    if (!this.pmodule.guid) {
      // выходим если это новый ПМ
      return;
    }

    const {data} = await httpClient.get(`modules/`, {
      params: {
        guids: JSON.stringify([this.pmodule.guid]),
      },
    });
    const amId = data[0].hw_pm;
    if (amId != null) {
      const {data} = await httpClient.get<[]>(`hardware/${amId}`);
      this.am = data;
    }
  }

  nodeFieldClick(index: number) {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[index].node_id : 0}`); //TODO: fix it?
  }

  async created() {
    if (this.pmodule.nodes && this.pmodule.nodes.length) {
      const totalNodeNames: {title: string; value: number}[] = [];
      const nodesIds: number[] = this.pmodule.nodes.map((item, index) => index);

      const getNameNode = async (idx: number) => {
        if (this.pmodule.nodes) {
          const {data} = await nodeModule.edit(this.pmodule.nodes[idx].node_id);
          return {title: data.name, value: data.id ?? 0};
        }
      };

      for (const item of nodesIds) {
        const result = await getNameNode(item);
        if (result) {
          totalNodeNames.push(result);
        }
      }
      this.nodeName = totalNodeNames;
    }
    await this.loadAM();
    //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
    this.pmodule.measurements.forEach((elem: any) => {
      if (!elem.isNew) {
        elem.isActive = true;
        elem.isNew = false;
      }
    });

    if (this.fromHardware && this.pmodule && this.mac) {
      this.pmodule.device = this.mac;
    }

    if (this.fromHardware) this.showMac = false;

    await this.loadMeasurements();
    // получаем все модули и находим dtcp-сервер
    await pmoduleModule.fetchAll();
    const dtcpServers = pmoduleModule.all.filter(x => x.type === PModuleType.DtcpServerModule);
    if (dtcpServers.length) {
      // если есть dtcp-сервера, берем один из них
      const dtcpServer = dtcpServers[0];

      if (dtcpServer.guid) {
        //подключаемся к веб сокету
        this.socket = connectionGetActiveDevices(dtcpServer.guid);
        this.socket.onopen = () => {
          //отправляем action
          if (dtcpServer.id) {
            dtcpServerStoreModule.processGetActiveDevicesAction({id: dtcpServer.id});
          }
        };
        this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
      }
    }
  }

  subscribeConectionWS(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    const macs = strParse.data.devices.map((x: any) => ({
      device: x.mac,
      description: `${x.mac} - ${x.type} (${x.fw_ver})`,
    }));
    // нужно также объединить полученные mac адреса вместе с текущим, если он есть
    if (
      this.pmodule.device &&
      this.macs.filter(v => v.device === this.pmodule.device).length <= 0
    ) {
      this.macs = [...macs, {device: this.pmodule.device, description: this.pmodule.device}];
    } else {
      this.macs = [...macs];
    }
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/sensors');
    } else router.push('/sensors');
  }
}
